import React from "react";
import startCase from "lodash/startCase";
import orderBy from "lodash/orderBy";
import PriceSelectOption from "../PriceSelectOption";
import CreatePriceCallout from "./CreatePriceCallout";
import { INTERVAL_LABELS_MAP } from "components/FormerEditor/common/constants";
import classnames from "classnames";

const IntervalPrices = ({ isFirst, interval, prices, primary }) => {
  const orderedIntervalPrices = orderBy(prices, ["unit_amount"], ["asc"]);
  const intervalLabel = INTERVAL_LABELS_MAP[interval];
  let priceOptionNodeContent;

  if (orderedIntervalPrices && orderedIntervalPrices.length) {
    priceOptionNodeContent = orderedIntervalPrices.map((price, priceIx) => {
      const isPriceFirst = !priceIx;
      const isPriceLast = priceIx === orderedIntervalPrices.length - 1;

      const selected = Boolean(primary && price.id === primary.price);
      return (
        <PriceSelectOption
          isFirst={isPriceFirst}
          isLast={isPriceLast}
          key={priceIx}
          priceIx={priceIx}
          price={price}
          selected={selected}
        />
      );
    });
  } else {
    priceOptionNodeContent = <CreatePriceCallout priceLabel={intervalLabel} />;
  }

  return (
    <div
      className={classnames("w-100", {
        pt3: !isFirst
      })}
      key={interval}
    >
      <label className="f6 pb3 dib fw5">{startCase(intervalLabel)}</label>
      <ul className="ma0 pa0 list">{priceOptionNodeContent}</ul>
    </div>
  );
};

export default IntervalPrices;
